import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrdenMenuService {

  num_orden : number;
  dialogRef : any;

  constructor() { }
}
